import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import ReplyRightIcon from '@atlaskit/icon-lab/core/reply-right';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.status-field.icon-label',
		defaultMessage: 'Status field icon',
		description:
			'Accessible label for the icon representing the status field in a Jira work item action card.',
	},
});

export function StatusFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<ReplyRightIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
